export const handleAsylumStatuses = ({ asylumStatus }) => {
  return asylumStatus.map(status => {
    if (status.hasAtUnd) {
      return {
        name: 'Har rätt att jobba',
        type: 'asylumStatus',
        path: 'hasAtUnd',
        value: true
      }
    } else if (status.hasResidencePermit) {
      return {
        name: 'Har uppehållstillstånd',
        type: 'asylumStatus',
        path: 'hasResidencePermit',
        value: true
      }
    } else {
      return {
        name: 'Har inte rätt att jobba än',
        type: 'asylumStatus',
        path: 'hasAtUnd',
        value: false
      }
    }
  })
}

export const formatSearchTags = tags => {
  return Object.keys(tags)
    .map(key => {
      if (key === 'asylumStatus') {
        return handleAsylumStatuses(tags)
      }

      return tags[key].map(t => ({
        ...t,
        type: key
      }))
    })
    .filter(Boolean)
    .reduce((p, c) => p.concat(c), [])
}



// WEBPACK FOOTER //
// ./src/utils/tagHelpers.js